import axios from 'axios'
import Cluster from './Bdmap/clusterLayerJs'
// import BMap from 'BMap'
const CancleToken = axios.CancelToken
const ApiCtl = {
  /** 查询组织设备
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param pageSize {number} 页面容量
   * @param pageNum {number} 页码
   */
  getLocationByDevName: function (_this, url, pageSize, pageNum, flag) {
    let that = _this
    let data = {
      orgId: _this.treeOrgId,
      status: _this.lImmediatelyStatus,
      devType: _this.devType === undefined ? null : _this.devType
    }
    if (_this.searchTextType) {
      if (_this.searchTextType === 'devImei') {
        data.devImei = _this.searchText
      } else if (_this.searchTextType === 'devName') {
        data.devName = _this.searchText
      }
    }
    _this
      .$axios({
        method: 'post',
        url: url,
        data: data,
        params: {
          pageNum: pageNum,
          pageSize: pageSize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.miniTable = false
          _this.orgdevlist = resp.data.data.pag
          _this.totalNum = resp.data.data.total
          if (flag === 'toggle') {
            that.$nextTick(() => {
              that.$refs.trackingList.$refs.multipleTable.toggleRowSelection(
                {
                  devId: that.$route.params.devId,
                  devImei: that.$route.params.devImei
                },
                true
              )
              // 选中当前行
              that.handleSelectChange({
                devId: that.$route.params.devId,
                devImei: that.$route.params.devImei
              }) // 在地图中展示小车
            })
          }
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('查询失败！' + resp)
      })
  },
  /** 组织书过滤器数据
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   */
  getOrg: function (_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.roleLoading = false
          _this.restaurants = resp.data.data.pag.map(item => ({
            value: item.orgName
          }))
          _this.$emit('restaurants', resp.data.data.pag)
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('查询失败！' + resp)
      })
  },
  /** 查询组织设备
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgName {string} 接口地址
   */
  // getOrgidByName: function (_this, url, orgName) {
  //   _this.$axios({
  //     method: 'post',
  //     url: url,
  //     data: {
  //       usernameNow: JSON.parse(sessionStorage.getItem('userInfo')).username,
  //       uOrgIdNow: JSON.parse(sessionStorage.getItem('userInfo')).uOrgId,
  //       orgIdsList: JSON.parse(sessionStorage.getItem('userInfo')).orgIdsList,
  //       orgName: orgName
  //     },
  //     headers: {
  //       Authorization: sessionStorage.getItem('token')
  //     }
  //   }).then(function (resp) {
  //     if (resp.data.code === 200) {
  //       _this.searchOrgId = [resp.data.data.pag[0].orgId]
  //       _this.$refs.orgTree.setCurrentKey(resp.data.data.pag[0].orgId)
  //     } else {
  //       _this.$message({
  //         message: resp.data.message,
  //         type: 'warning'
  //       })
  //     }
  //   }).catch(resp => {
  //     console.log('查询失败！' + resp)
  //   })
  // },
  /** 查询所有设备
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   */
  getAllDeviceList: function (_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.tableData = resp.data.data.list
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('查询所有设备！' + resp)
      })
  },
  /** 新建设备
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {object} 表单提交对象
   */
  addDevice: function (_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devImei: data.devImei,
          devName: data.devName,
          devNetTime: data.devNetTime,
          devProtocolType: data.devProtocolType,
          devType: data.devType,
          orgId: data.orgId,
          devModel: data.devModel,
          devUse: data.devUse
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.$message({
            message: '新建设备成功',
            type: 'success'
          })
          _this.createDialogFormVisible = false
          _this.$refs.creatFrom.resetFields()
          _this.$parent.getDevList()
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(err => {
        console.log('新增设备失败' + err)
      })
  },
  /** 删除设备
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param devIds {Array} 设备ID
   */
  deleteDevice: function (_this, url, devIds, treeOrgId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: devIds,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.$message({
            message: '删除成功！',
            type: 'success'
          })
          _this.getDevList()
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('删除设备' + resp)
      })
  },
  /** 所有组织
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   */
  getAllOrg: function (_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.treeLoading = false
          _this.dataTree = resp.data.data
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  /** 查询所有设备 async/await 处理异步
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param devId {string} 设备ID
   */
  async getDeviceInfo(_this, url, devId, orgId) {
    await _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devId: devId,
          orgId: orgId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.fenceDevData = resp.data.data.pag
          _this.devInfoData = resp.data.data.pag[0]
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('查询所有设备 async/await 处理异步' + resp)
      })
  },
  /** 修改设备信息
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {object} 表单提交对象
   */
  updateDeviceInfo: function (_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devId: data.devId,
          devImei: data.devImei,
          devModel: data.devModel,
          devName: data.devName,
          devNetTime: data.devNetTime,
          devProtocolType: data.devProtocolType,
          devType: data.devType,
          orgId: data.orgId,
          devUse: data.devUse
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.$message({
            message: '修改设备成功',
            type: 'success'
          })
          _this.$refs.devInfoData.resetFields()
          _this.editInfoDialogVisible = false
          _this.$parent.getDevList()
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
          console.log(resp.data)
        }
      })
      .catch(err => {
        console.log('修改设备信息' + err)
      })
  },
  /** 根据组织ID查设备列表
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgId {string} 组织ID
   * * * * @param pageSize {number} 分页容量
   * * * * * @param pageNum {number} 当前页码
   */
  getAllDeviceOrganizationListDev(
    _this,
    url,
    orgId,
    pageSize,
    pageNum,
    status,
    devName,
    devImei
  ) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          orgId: orgId,
          devName: devName,
          status: status,
          devImei: devImei
        },
        params: {
          pageNum: pageNum,
          pageSize: pageSize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.tableloading = false
          _this.miniTable = false
          _this.totalNum = resp.data.data.total
          _this.orgdevlist = resp.data.data.pag
          _this.tableData = resp.data.data.pag
        }
      })
      .catch(resp => {
        console.log('根据组织ID查设备列表' + resp)
      })
  },
  /** 根据组织ID查设备列表
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgId {string} 组织ID
   * * * * @param pageSize {number} 分页容量
   * * * * * @param pageNum {number} 当前页码
   */
  getAllListDev(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          pageNum: 0,
          pageSize: 0
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.allDevList = resp.data.data.pag
        }
      })
      .catch(resp => {
        console.log('根据组织ID查设备列表' + resp)
      })
  },
  /** 查询设备信息、列表+分页、【可根据组织id、设备imei编号、设备名称(模糊查询)、设备实时状态查询
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param devId {string} 设备ID
   */
  efenceGetDeviceByOrgId(_this, url, orgId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          orgId: orgId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.fenceDevData = resp.data.data.pag
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('查询所有设备 async/await 处理异步' + resp)
      })
  },
  /** 根据组织ID查设备列表
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgId {string} 组织ID
   * * * * @param pageSize {number} 分页容量
   * * * * * @param pageNum {number} 当前页码
   */
  getDeviceByOrgId(_this, url, orgId, pageSize, pageNum, devName) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          orgId: orgId,
          devName: devName
        },
        params: {
          pageNum: pageNum,
          pageSize: pageSize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.tableloading = false
          _this.miniTable = false
          _this.totalNum = resp.data.data.total
          if (resp.data.data.list) {
            _this.orgdevlist = resp.data.data.list
            _this.tableData = resp.data.data.list
          } else {
            _this.orgdevlist = resp.data.data.pag
            _this.tableData = resp.data.data.pag
          }
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('根据组织ID查设备列表' + resp)
      })
  },
  /** 计数
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgId {string} 组织ID
   */
  getDeviceStatusNum(_this, url, orgId, pageSize, pageNum) {
    _this
      .$axios({
        method: 'post',
        url: '/locationbs/monitoring/device/status/count',
        data: {
          orgId: orgId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          // 计数
          _this.Num1 = resp.data.data.drivingNum
          _this.Num2 = resp.data.data.stillnessNum
          _this.Num3 = resp.data.data.dormancyNum
          _this.Num4 = resp.data.data.offlineNum
          _this.Num5 = 0
          _this.Num6 = resp.data.data.warningNum
        }
      })
      .catch(resp => { })
  },
  /** 根据组织id查询设备定位信息
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgId {string} 组织ID
   * * * * @param pageSize {string} 分页容量
   * * * * * @param pageNum {string} 页码
   */
  getDeviceLocationsByOrgId(_this, url, orgId, pageSize, pageNum) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          orgId: orgId,
          pageNum: pageNum,
          pageSize: pageSize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.totalNum = resp.data.data.total
          _this.orgdevlist = resp.data.data.list
          _this.tableData = resp.data.data.list
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        console.log('根据组织id查询设备定位信息' + resp)
      })
  },
  /** 获取设备定位详细信息
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param devIdList {Array} 设备ID
   * * * * @param callback {Function} 回调函数
   */
  getLocationByDevId(_this, url, devIdList, callback) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devIdList: devIdList
        },
        cancelToken: new CancleToken(function (c) {
          _this.cancel = c
        }),
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          let data = resp.data.data.pag[0]
          if (resp.data.data.pag.length !== 0) {
            if (!data.lLatBd09 || !data.lLonBd09) {
              _this.$message.warning('该设备从未上传过定位数据')
              if (_this.$route.path === '/expressway/dev-sbgl') {
                _this.hasLocation = false
                _this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 5)
              }
              return false
            } else {
              _this.hasLocation = true
            }
            resp.data.data.pag[0].devId = resp.data.data.pag[0].devId.toString()// 转成string防止丢失精度
            resp.data.data.pag.forEach(item => {
              item.coordinate = item.lLonBd09 + ',' + item.lLatBd09
            })
            _this.watchDeviceList = resp.data.data.pag
            resp.data.data.pag[0].date = resp.data.data.pag[0].lRecordTime.slice(
              0,
              10
            )
            resp.data.data.pag[0].time = resp.data.data.pag[0].lRecordTime.slice(
              10,
              resp.data.data.pag[0].lRecordTime.length
            )
            resp.data.data.pag[0].date1 = resp.data.data.pag[0].createTime.slice(
              0,
              10
            )
            resp.data.data.pag[0].time1 = resp.data.data.pag[0].createTime.slice(
              10,
              resp.data.data.pag[0].createTime.length
            )
            _this.watchDevice = resp.data.data.pag[0]

            // 清除之前的地址信息，确保显示最新的经纬度
            if (_this.coordinate !== undefined) {
              _this.coordinate = undefined;
            }
            if (_this.watchDevice.displayAddress !== undefined) {
              _this.$delete(_this.watchDevice, 'displayAddress');
            }

            if (
              _this.watchDevice.lLonBd09 !== null &&
              _this.watchDevice.lLatBd09 !== null
            ) {
              // 坐标显示保留6位小数，此数据仅展示，不参与逻辑
              let lon = _this.watchDevice.lLonBd09 * 1
              let lat = _this.watchDevice.lLatBd09 * 1
              _this.watchDevice.coordinate = lon.toFixed(6) + ' , ' + lat.toFixed(6)
            } else {
              _this.watchDevice.coordinate = '暂无位置信息'
            }
            // 缓存位置数据
            _this.cachedLocationData = resp.data.data.pag;

            // 根据地图类型处理标记显示
            if (_this.mapType === 'baidu' && _this.map) {
              Cluster.setLayer(
                _this.map,
                resp.data.data.pag,
                _this.markerList,
                _this
              )
              let points = []
              resp.data.data.pag.forEach(item => {
                points.push(new BMap.Point(item.lLonBd09, item.lLatBd09))
              })
              if (points.length > 0) {
                _this.map.setViewport(points);
              }

              // 强制刷新聚合器显示
              if (_this.markerCluster) {
                _this.markerCluster.clearMarkers();
                _this.markerCluster.addMarkers(_this.markerList);
              }
            } else if (_this.mapType === 'amap' && _this.amap) {
              // 高德地图处理
              _this.updateAmapMarkers(resp.data.data.pag);
            } else if (_this.mapName === 'BD') {
              // 兼容旧的mapName方式
              Cluster.setLayer(
                _this.map,
                resp.data.data.pag,
                _this.markerList,
                _this
              )
              let points = []
              resp.data.data.pag.forEach(item => {
                points.push(new BMap.Point(item.lLonBd09, item.lLatBd09))
              })
              if (points.length > 0) {
                _this.map.setViewport(points);
              }

              // 强制刷新聚合器显示
              if (_this.markerCluster) {
                _this.markerCluster.clearMarkers();
                _this.markerCluster.addMarkers(_this.markerList);
              }
            } else if (_this.mapName === 'GD') {
              // 使用高德地图组件更新标记，避免与 PointCtr 冲突
              if (_this.gaodeMapComponent) {
                _this.gaodeMapComponent.updateMarkers(resp.data.data.pag);
              }
            }

            // 如果提供了回调函数，调用它
            if (callback && typeof callback === 'function') {
              callback(resp.data.data.pag);
            }
          }
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })

          // 即使出错也要调用回调函数
          if (callback && typeof callback === 'function') {
            callback([]);
          }
        }
      })
      .catch(error => {
        console.error('获取设备位置信息失败:', error);

        // 出现异常时也要调用回调函数
        if (callback && typeof callback === 'function') {
          callback([]);
        }
      })
  },
  getLocationByDevIdLeaflet(_this, url, devIdList) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devIdList: devIdList
        },
        cancelToken: new CancleToken(function (c) {
          _this.cancel = c
        }),
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          if (resp.data.data.pag.length !== 0) {
            _this.watchDeviceList = resp.data.data.pag

            _this.watchDevice = resp.data.data.pag[0]
            if (
              _this.watchDevice.lLonWgs84 !== null &&
              _this.watchDevice.lLatWgs84 !== null
            ) {
              // 坐标显示保留6位小数，此数据仅展示，不参与逻辑
              let lon = _this.watchDevice.lLonWgs84 * 1
              let lat = _this.watchDevice.lLatWgs84 * 1
              console.log(' _this.watchDeviceList', _this.watchDevice)
              _this.coordinate = lon.toFixed(6) + ' , ' + lat.toFixed(6)
            } else {
              _this.coordinate = '暂无位置信息'
            }
            console.log(resp.data.data.pag)
            Cluster.setLayer(
              _this.map,
              resp.data.data.pag,
              _this.markerList,
              _this
            )
            let points = []
            resp.data.data.pag.forEach(item => {
              points.push(new BMap.Point(item.lLonWgs84, item.lLatWgs84))
            })
            _this.map.setViewport(points)
          }
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 搜索设备
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param pageNum {number} 分页号
   * * * * @param pageSize {number} 分页容量
   * * * * * @param searchText {string} 搜索内容
   * * * * * * @param devUseStatus {string} 使用状态
   * * * * * * * @param value {string} 筛选字段
   */
  async getAllDeviceOrganizationList(
    _this,
    url,
    pageNum,
    pageSize,
    searchText,
    devUseStatus,
    value,
    orgId,
    devType
  ) {
    _this.tableloading = true
    let data = {
      status: devUseStatus,
      orgId: orgId,
      devType: devType
    }
    if (value === 'devImei') {
      let arr = []

      if (searchText) {
        searchText.toString().split(',').forEach(item => {
          arr.push(item.trim())
        })
      }// 加个toString()，避免split方法报错

      arr.length > 1
        ? (data.imeiList = arr) // 批量搜和普通搜合并
        : (data.devImei = arr[0])
    } else if (value === 'devName') {
      data.devName = searchText
    }
    await _this
      .$axios({
        method: 'post',
        url: url,
        data: data,
        params: {
          pageNum: pageNum,
          pageSize: pageSize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        _this.tableloading = false
        if (resp.data.code === 200) {
          _this.tableData = resp.data.data.pag
          _this.totalNum = resp.data.data.total
          // if (_this.$route.params.devImei && _this.tableData.length == 1) {
          //   setTimeout(() => {
          //     _this.getdeviceId(_this.tableData[0])
          //   }, 1000)
          // }
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        _this.tableloading = false
        _this.$message({
          message: '查询失败！请稍后再试！',
          type: 'warning'
        })
        console.log('查询失败！' + resp)
      })
  },
  /** 高级搜索
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param searchForm {Array} 搜索内容
   */
  async getAllDeviceOrganizationList2(_this, url, searchForm) {
    await _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devImei: searchForm.devImei,
          devName: searchForm.devName,
          devProtocolType: searchForm.devProtocolType,
          devType: searchForm.devType,
          devUseStatus: searchForm.devUseStatus,
          OrgId: searchForm.uOrgId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (resp) {
        if (resp.data.code === 200) {
          _this.$parent.tableData = resp.data.data.pag
          _this.dialogFormVisible = false
          _this.$refs.searchForm.resetFields()
        } else {
          _this.$message({
            message: resp.data.message,
            type: 'warning'
          })
        }
      })
      .catch(resp => {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      })
  },
  /** 根据登录用户信息获取组织
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param orgId {string} 组织id
   * @param pageSize {number} 页面容量
   * @param currentPage {number} 当前页码
   */
  getDeviceLocationByOrgId: function (_this, url, orgId, pageSize, currentPage) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          orgId: orgId
        },
        params: {
          pageSize: pageSize,
          pageNum: currentPage
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.orgDevList = res.data.data.list
          _this.totalNum = res.data.data.total
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 获取所有任务列表
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param orgId {string} 组织id
   * @param ewName {string} 任务名称
   * @param pageSize {number} 页面容量
   * @param currentPage {number} 当前页码
   */
  getAllExpresswayWorkList(
    _this,
    url,
    orgId,
    ewName,
    pageSize,
    currentPage,
    ewId
  ) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          ewId: ewId,
          ewOrgId: orgId,
          ewName: ewName
        },
        params: {
          pageSize: pageSize,
          pageNum: currentPage
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.tableData = res.data.data.pag
          _this.missionLoading = false
          _this.totalNum = res.data.data.total
          for (let item in _this.tableData) {
            if (
              _this.tableData[item].lonWgs84 &&
              _this.tableData[item].latWgs84
            ) {
              let lng = _this.tableData[item].lonWgs84 * 1
              let lat = _this.tableData[item].latWgs84 * 1
              _this.tableData[item].coordinate =
                lng.toFixed(6) + ',' + lat.toFixed(6)
            }
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 根据id获取任务信息
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务id
   */
  async getAllExpresswayWorkListByEwid(_this, url, ewId) {
    await _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.missionInfoData = res.data.data.pag[0]
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 修改任务
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {object} 表单数据
   */
  updateExpresswayWork(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          latWgs84: data.latWgs84,
          lonWgs84: data.lonWgs84,
          ewId: data.ewId,
          ewState: data.ewState,
          ewName: data.mname,
          ewOrgId: data.uOrgId,
          ewType: data.mType,
          ewPlanBeginTime: data.mTime[0],
          ewPlanEndTime: data.mTime[1],
          ewRemark: data.mRemark,
          ewCompanyId: data.ewCompanyId,
          configId: data.configId,
          efence: data.efence,
          guide: data.guide
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '保存成功',
            type: 'success'
          })
          _this.$parent.refreshTableData()
          _this.editMissionDialogVisible = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 新建任务
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {object} 表单数据
   */
  addExpresswayWork(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          ewName: data.mname,
          ewOrgId: data.uOrgId,
          ewType: data.mType,
          latWgs84: data.latWgs84,
          lonWgs84: data.lonWgs84,
          ewPlanBeginTime: data.mTime[0],
          ewPlanEndTime: data.mTime[1],
          ewRemark: data.mRemark,
          configId: data.configId,
          efence: data.efence,
          guide: data.guide
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '任务创建成功',
            type: 'success'
          })
          _this.$parent.refreshTableData()
          _this.createMissionDialogVisible = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 删除任务
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {Array} 删除ID集合
   */
  delExpresswayWork(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: data,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '任务删除成功',
            type: 'success'
          })
          _this.refreshTableData()
          _this.$refs.multipleTable.clearSelection()
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 删除任务
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param pageSize {number} 页面容量
   * @param currentPage {number} 当前页码
   * * @param eeName {number} 员工名
   */
  getAllExpresswayEmplList(_this, url, pageSize, currentPage, eeName, orgId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          eeName: eeName,
          eeOrgId: orgId
        },
        params: {
          pageSize: pageSize,
          pageNum: currentPage
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.totalNum = res.data.data.total
          _this.tableData = res.data.data.pag
          _this.employeeLoading = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 根据ID查询员工信息
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param eeId {string} 员工id
   */
  getAllExpresswayEmplListByID(_this, url, eeId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          eeId: eeId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.empInfoData = res.data.data.pag[0]
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 新建员工
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {Object} 表单对象
   */
  addExpresswayEmpl(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          eeUsername: data.eeUsername,
          eeMobile: data.eeMobile,
          eeName: data.eeName,
          eeOrgId: data.eeOrgId,
          eeRemark: data.eeRemark
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '员工创建成功',
            type: 'success'
          })
          _this.$parent.refreshTableData()
          _this.createEmployeeDialogVisible = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 删除员工
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {Array} 删除ID集合
   */
  delExpresswayEmpl(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: data,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '删除成功',
            type: 'success'
          })
          _this.refreshTableData()
          _this.$refs.employeeTable.clearSelection()
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 编辑员工
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {Object} 表单对象
   */
  updateExpresswayEmpl(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          eeId: data.eeId,
          eeMobile: data.eeMobile,
          eeName: data.eeName,
          eeOrgId: data.eeOrgId,
          eeRemark: data.eeRemark,
          eeUsername: data.eeUsername
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '保存成功',
            type: 'success'
          })
          _this.$parent.refreshTableData()
          _this.editEmployeeDialogVisible = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询空闲员工
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param orgId {string} 任务组织
   * @param missionEmp {Array} 任务组织
   */
  getAllExpresswayEmplListNotBinding(_this, url, orgId, missionEmp) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          eeOrgId: orgId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.ExpresswayEmplData = res.data.data.pag
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询设备
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param pageSize {number} 分页容量
   * @param currentPage {number} 页码
   * @param orgId {string} 任务组织
   */
  expresswayDeviceGetAllDeviceList(_this, url, pageSize, currentPage, orgId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          orgId: orgId
        },
        params: {
          pageSize: pageSize,
          pageNum: currentPage
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.totalNum = res.data.data.total
          _this.ExpresswayDevData = res.data.data.pag
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 任务绑定员工
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   */
  getExpresswayEmplByewId(_this, url, ewId) {
    _this
      .$axios({
        method: 'get',
        url: url,
        params: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.missionEmp = []
          for (let item = 0; item < res.data.data.pag.length; item++) {
            _this.missionEmp.push(res.data.data.pag[item].eeId)
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询任务已绑定设备并筛选已分配(锥桶)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   */
  getDeviceByewIdAndSetDisabledEfence(
    _this,
    url,
    urls,
    ewId,
    orgId,
    pageSize,
    currentPage,
    devModels
  ) {
    _this
      .$axios({
        method: 'post',
        url: url,
        params: {
          ewId: ewId
        },
        data: devModels,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.missionEfence = []
          for (let item = 0; item < res.data.data.pag.length; item++) {
            _this.missionEfence.push(res.data.data.pag[item].devId)
          }
          _this
            .$axios({
              method: 'post',
              url: urls,
              data: {
                orgId: orgId,
                devModel: '1',
                devModels: devModels
              },
              params: {
                pageSize: pageSize,
                pageNum: currentPage
              },
              headers: {
                Authorization: sessionStorage.getItem('token')
              }
            })
            .then(function (res) {
              if (res.data.code === 200) {
                _this.totalNum = res.data.data.total
                _this.ExpresswayEfenceData = res.data.data.pag
                // 已有任务的设备不能分配新任务，但可以从已绑定任务中移除
                for (let i in _this.ExpresswayEfenceData) {
                  if (_this.missionEfence.length === 0) {
                    _this.ExpresswayEfenceData[i].disabled =
                      _this.ExpresswayEfenceData[i].flag
                  } else {
                    if (
                      _this.missionEfence.indexOf(
                        _this.ExpresswayEfenceData[i].devId
                      ) > -1
                    ) {
                      _this.ExpresswayEfenceData[i].disabled = false
                    } else if (
                      _this.missionEfence.indexOf(
                        _this.ExpresswayEfenceData[i].devId
                      ) === -1 &&
                      _this.ExpresswayEfenceData[i].flag === true
                    ) {
                      _this.ExpresswayEfenceData[i].disabled = true
                    }
                  }
                }
                _this.efenceLoading = false
              } else {
                _this.$message({
                  message: res.data.message,
                  type: 'warning'
                })
              }
            })
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询任务已绑定设备并筛选已分配(喷水)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   */
  getDeviceByewIdAndSetDisabledGuide(
    _this,
    url,
    urls,
    ewId,
    orgId,
    pageSize,
    currentPage,
    devModels
  ) {
    _this
      .$axios({
        method: 'post',
        url: url,
        params: {
          ewId: ewId
        },
        data: devModels,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.missionGuide = []
          for (let item = 0; item < res.data.data.pag.length; item++) {
            _this.missionGuide.push(res.data.data.pag[item].devId)
          }
          _this
            .$axios({
              method: 'post',
              url: urls,
              data: {
                orgId: orgId,
                devModel: '1',
                devModels: devModels
              },
              params: {
                pageSize: pageSize,
                pageNum: currentPage
              },
              headers: {
                Authorization: sessionStorage.getItem('token')
              }
            })
            .then(function (res) {
              if (res.data.code === 200) {
                _this.totalNum = res.data.data.total
                _this.ExpresswayGuideData = res.data.data.pag
                // 已有任务的设备不能分配新任务，但可以从已绑定任务中移除
                for (let i in _this.ExpresswayGuideData) {
                  if (_this.missionGuide.length === 0) {
                    _this.ExpresswayGuideData[i].disabled =
                      _this.ExpresswayGuideData[i].flag
                  } else {
                    // 如果找到了
                    if (
                      _this.missionGuide.indexOf(
                        _this.ExpresswayGuideData[i].devId
                      ) > -1
                    ) {
                      _this.ExpresswayGuideData[i].disabled = false
                    } else {
                      _this.ExpresswayGuideData[i].disabled = true
                    }
                    if (
                      _this.missionGuide.indexOf(
                        _this.ExpresswayGuideData[i].devId
                      ) === -1 &&
                      _this.ExpresswayGuideData[i].flag === true
                    ) {
                      _this.ExpresswayGuideData[i].disabled = true
                    }
                  }
                }
                _this.guideLoading = false
              } else {
                _this.$message({
                  message: res.data.message,
                  type: 'warning'
                })
              }
            })
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询任务已绑定设备并筛选已分配(除喷水和锥桶)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   */
  getDeviceByewIdAndSetDisabled(
    _this,
    url,
    urls,
    ewId,
    orgId,
    pageSize,
    currentPage,
    devModels
  ) {
    _this
      .$axios({
        method: 'post',
        url: url,
        params: {
          ewId: ewId
        },
        data: devModels,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.missionDev = []
          for (let item = 0; item < res.data.data.pag.length; item++) {
            _this.missionDev.push(res.data.data.pag[item].devId)
          }
          _this
            .$axios({
              method: 'post',
              url: urls,
              data: {
                orgId: orgId,
                devModel: '1',
                devModels: devModels
              },
              params: {
                pageSize: pageSize,
                pageNum: currentPage
              },
              headers: {
                Authorization: sessionStorage.getItem('token')
              }
            })
            .then(function (res) {
              if (res.data.code === 200) {
                _this.totalNum = res.data.data.total
                _this.ExpresswayDevData = res.data.data.pag
                // 已有任务的设备不能分配新任务，但可以从已绑定任务中移除
                for (let i in _this.ExpresswayDevData) {
                  if (_this.missionDev.length === 0) {
                    _this.ExpresswayDevData[i].disabled =
                      _this.ExpresswayDevData[i].flag
                  } else {
                    if (
                      _this.missionDev.indexOf(
                        _this.ExpresswayDevData[i].devId
                      ) > -1
                    ) {
                      _this.ExpresswayDevData[i].disabled = false
                    } else if (
                      _this.missionDev.indexOf(
                        _this.ExpresswayDevData[i].devId
                      ) === -1 &&
                      _this.ExpresswayDevData[i].flag === true
                    ) {
                      _this.ExpresswayDevData[i].disabled = true
                    }
                  }
                }
                _this.devLoading = false
              } else {
                _this.$message({
                  message: res.data.message,
                  type: 'warning'
                })
              }
            })
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 任务绑定员工并筛选已分配
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   * @param missionEmp {Array} 任务已有员工ID集合
   */
  getExpresswayEmpByEwIdAndSetDisabled(_this, url, urls, ewId, orgId) {
    _this
      .$axios({
        method: 'get',
        url: url,
        params: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.missionEmp = []
          for (let item = 0; item < res.data.data.pag.length; item++) {
            _this.missionEmp.push(res.data.data.pag[item].eeId)
          }
          _this
            .$axios({
              method: 'post',
              url: urls,
              data: {
                eeOrgId: orgId
              },
              params: {
                ewId: ewId
              },
              headers: {
                Authorization: sessionStorage.getItem('token')
              }
            })
            .then(function (resp) {
              if (resp.data.code === 200) {
                _this.ExpresswayEmplData = resp.data.data.pag
                // 已有任务的员工不能分配新任务，但可以从已绑定任务中移除
                for (let item in _this.ExpresswayEmplData) {
                  if (_this.missionEmp.length === 0) {
                    _this.ExpresswayEmplData[item].disabled =
                      _this.ExpresswayEmplData[item].flag === true
                  } else {
                    if (
                      _this.missionEmp.indexOf(
                        _this.ExpresswayEmplData[item].eeId
                      ) > -1
                    ) {
                      _this.ExpresswayEmplData[item].disabled = false
                    } else if (
                      _this.missionEmp.indexOf(
                        _this.ExpresswayEmplData[item].eeId
                      ) === -1 &&
                      _this.ExpresswayEmplData[item].flag === true
                    ) {
                      _this.ExpresswayEmplData[item].disabled = true
                    }
                  }
                }
                _this.empLoading = false
              } else {
                console.log(resp)
                _this.$message({
                  message: resp.data.message,
                  type: 'warning'
                })
              }
            })
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询任务已绑定设备
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   */
  getDeviceByewId(_this, url, ewId, devModels) {
    _this
      .$axios({
        method: 'get',
        url: url,
        params: {
          ewId: ewId
        },
        data: devModels,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.missionDev = []
          for (let item = 0; item < res.data.data.pag.length; item++) {
            _this.missionDev.push(res.data.data.pag[item].devId)
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 任务绑定员工
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   */
  getExpresswayEmplListByewId(_this, url, ewId) {
    _this
      .$axios({
        method: 'get',
        url: url,
        params: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.empTableData = res.data.data.pag
          _this.empInfo = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询任务已绑定设备
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   */
  getDeviceListByewId(_this, url, ewId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        params: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.devTableData = res.data.data.pag
          _this.devInfo = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 任务分配员工
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  workBindingEmpl(_this, url, ewId, emplIds) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: emplIds,
        params: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.nextBtn = false
          _this.nextBtnDisabled = true
          _this.editableTabsValue = '1'
          _this.commitBtnDisabled = false
          _this.tabFirst = true
          _this.tabSecond = false
          _this.ExpresswayEmplList = []
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 任务分配设备
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param devIds {Array} 接口地址
   */
  workBindingDevice(_this, url, ewId, devIds) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: devIds,
        params: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.ExpresswayDevList = []
          _this.setEmployeeDialogVisible = false
          _this.$message({
            message: '任务配置完成',
            type: 'success'
          })
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 任务管理组织树
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  expresswayWorkGetAllOrganizationList(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.dataTree = res.data.data
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 人员管理组织树
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  expresswayEmplGetAllOrganizationList(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.dataTree = res.data.data
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 任务监控组织树
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  expresswayMonitoringGetAllOrganizationList(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.dataTree = res.data.data
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 获取任务下电子围栏
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param BMap {Array} 地图实例
   */
  getExpresswayEfenceByewId(_this, url, ewId, BMap, map) {
    _this
      .$axios({
        method: 'get',
        url: url,
        params: {
          ewId: ewId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        let polygonList = []
        if (res.data.code === 200) {
          if (res.data.data.pag.length > 0) {
            // 百度地图绘制围栏
            polygonList = res.data.data.pag[0].eefLocationBd09.split(',')
            let polygon = []
            for (let i = 0; i < polygonList.length; i++) {
              let poly = polygonList[i].split(' ')
              polygon.push(new BMap.Point(poly[0], poly[1]))
            }
            _this.map.setViewport(polygon)
            _this.map.addOverlay(
              new BMap.Polygon(polygon, {
                strokeColor: 'blue',
                strokeWeight: 1.5,
                strokeOpacity: 0.5
              })
            )
          }
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 监控任务下设备位置信息
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 任务ID
   * @param mState {number} 任务状态
   */
  monitoringByWorgId(_this, url, ewId, mState, BMap, BMapLib) {
    let locationType = ''
    locationType = 'bd09'
    _this
      .$axios({
        method: 'get',
        url: url,
        params: {
          ewId: ewId,
          locationType: locationType
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          if (res.data.data.length === 0) {
            clearInterval(_this.runTimer)
          } else {
            if (mState === 2) {
              // 创建数据中监控设备marker
              if (_this.markers.length === 0) {
                for (let i = 0; i < res.data.data.length; i++) {
                  // devModel=21 、22设备型号安全帽
                  let icon = null
                  let cautionStr = ''
                  if (
                    res.data.data[i].cId !== null &&
                    res.data.data[i].cId !== ''
                  ) {
                    let cautionList = res.data.data[i].cId.split(',')
                    for (let item in cautionList) {
                      for (let i = 0; i < _this.dictionaryList.length; i++) {
                        if (
                          _this.dictionaryList[i].dKey === cautionList[item] &&
                          _this.dictionaryList[i].dType === 'CAUTION_TYPE'
                        ) {
                          cautionStr =
                            cautionStr + _this.dictionaryList[i].dValue + ','
                        }
                      }
                    }
                  } else {
                    cautionStr = '设备参数正常'
                  }
                  if (
                    res.data.data[i].devModel === 21 ||
                    res.data.data[i].devModel === 22
                  ) {
                    let electric = null
                    if (res.data.data[i].lElectricQuantity * 1 > 90) {
                      electric = require('../assets/images/电池/100.png')
                    } else if (res.data.data[i].lElectricQuantity * 1 > 50) {
                      electric = require('../assets/images/电池/50-90.png')
                    } else if (res.data.data[i].lElectricQuantity * 1 > 20) {
                      electric = require('../assets/images/电池/20-50.png')
                    } else {
                      electric = require('../assets/images/电池/0-20.png')
                    }
                    if (res.data.data[i].flag === false) {
                      let html =
                        '<div style="width: 300px; height: 260px; background-color: #FFFFFF; border-radius: 5px; box-shadow: 3px 3px 3px 3px #e8e8e8;">' +
                        '<div style="width: 100%; height: 35px; border-radius: 5px 5px 0 0; border-bottom: #f1f1f1 solid 1px">' +
                        '<table>' +
                        '<tr>' +
                        '<td style="padding: 0">' +
                        '<div style="float: left; margin-left: 5px"><img src="' +
                        electric +
                        '" style="height: 20px; width: 20px; margin-top: 5px"></div>' +
                        '<div style="float: left; line-height: 30px; font-size: 12px; margin-left: 5px">' +
                        res.data.data[i].lElectricQuantity +
                        '%</div>' +
                        '</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电备份 3@2x.png') + '" style="height: 12px; width: 12px">15</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/编组 6@2x.png') + '" style="height: 12px; width: 12px">5</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电量备份 4@2x.png') + '" style="height: 12px; width: 12px">91%</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/信号备份 2@2x.png') + '" style="height: 12px; width: 12px"></td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/SIM 流量卡.png') + '" style="height: 12px; width: 12px"></td>' +
                        '</tr>' +
                        '</table>' +
                        '</div>' +
                        '<div style="width: 70%; float: right; padding: 10px 20px 0 20px">' +
                        '<table>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备名称:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        res.data.data[i].devName +
                        '</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备报警:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        cautionStr +
                        '</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备编号:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        res.data.data[i].devImei +
                        '</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">报警时间:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        res.data.data[i].lRecordTime +
                        '</td>' +
                        '</tr>' +
                        '</table>' +
                        '</div>' +
                        '<div style="width: 100%; height: 70px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px; margin-top: 120px">' +
                        '<span style="font-size: 12px; padding: 0 20px">告警位置：</span><br>' +
                        '<span style="font-size: 12px; padding: 0 20px">' +
                        _this.getAddress(
                          res.data.data[i].lLonBd09,
                          res.data.data[i].lLatBd09
                        ) +
                        '</span>' +
                        '</div>' +
                        '<div style="width: 100%; height: 35px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px">' +
                        '<table>' +
                        '<tr>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/help_location.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/help_od.png') +
                        '" style="height: 20px; width: 20"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/help_replay.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/main_msg_off.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/main_location_off.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '</tr>' +
                        '</table>' +
                        '</div>' +
                        '</div>'
                      icon = new BMap.Icon(
                        require('../assets/images/安全帽/报警.png'),
                        new BMap.Size(30, 30),
                        {
                          imageSize: new BMap.Size(30, 30)
                        }
                      )
                      // 自定义弹窗对象实例，并存入数组中
                      _this.infoBox.push({
                        infobox: new BMapLib.InfoBox(_this.map, html, {
                          boxStyle: {
                            width: '300px',
                            height: '260px'
                          },
                          offset: new BMap.Size(0, 20),
                          closeIconUrl: require('../assets/images/closeInfoBox.png'),
                          closeIconMargin: '10px 10px 0 0',
                          enableAutoPan: true
                        }),
                        devId: res.data.data[i].devId,
                        open: false
                      })
                    } else {
                      icon = new BMap.Icon(
                        require('../assets/images/安全帽/静止.png'),
                        new BMap.Size(30, 30),
                        {
                          imageSize: new BMap.Size(30, 30)
                        }
                      )
                    }
                    _this.markers.push({
                      marker: new BMap.Marker(
                        new BMap.Point(
                          res.data.data[i].lLonBd09,
                          res.data.data[i].lLatBd09
                        ),
                        {
                          icon: icon
                        }
                      ),
                      // 为marker集合元素添加设备ID 方便区分
                      id: res.data.data[i].devId
                    })
                  } else if (res.data.data[i].devModel === 30) {
                    let cautionStr = ''
                    if (
                      res.data.data[i].cId !== null &&
                      res.data.data[i].cId !== ''
                    ) {
                      let cautionList = res.data.data[i].cId.split(',')
                      for (let item in cautionList) {
                        for (let i = 0; i < _this.dictionaryList.length; i++) {
                          if (
                            _this.dictionaryList[i].dKey ===
                            cautionList[item] * 1 &&
                            _this.dictionaryList[i].dType === 'CAUTION_TYPE'
                          ) {
                            cautionStr =
                              cautionStr + _this.dictionaryList[i].dValue + ','
                          }
                        }
                      }
                    } else {
                      cautionStr = '正常'
                    }
                    if (
                      res.data.data[i].cId !== '' &&
                      res.data.data[i].cId !== null
                    ) {
                      let electric = null
                      if (res.data.data[i].lElectricQuantity * 1 > 90) {
                        electric = require('../assets/images/电池/100.png')
                      } else if (res.data.data[i].lElectricQuantity * 1 > 50) {
                        electric = require('../assets/images/电池/50-90.png')
                      } else if (res.data.data[i].lElectricQuantity * 1 > 20) {
                        electric = require('../assets/images/电池/20-50.png')
                      } else {
                        electric = require('../assets/images/电池/0-20.png')
                      }
                      let html =
                        '<div style="width: 300px; height: 260px; background-color: #FFFFFF; border-radius: 5px; box-shadow: 3px 3px 3px 3px #e8e8e8;">' +
                        '<div style="width: 100%; height: 35px; border-radius: 5px 5px 0 0; border-bottom: #f1f1f1 solid 1px">' +
                        '<table>' +
                        '<tr>' +
                        '<td style="padding: 0">' +
                        '<div style="float: left; margin-left: 5px"><img src="' +
                        electric +
                        '" style="height: 20px; width: 20px; margin-top: 5px"></div>' +
                        '<div style="float: left; line-height: 30px; font-size: 12px; margin-left: 5px">' +
                        res.data.data[i].lElectricQuantity +
                        '%</div>' +
                        '</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电备份 3@2x.png') + '" style="height: 12px; width: 12px">15</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/编组 6@2x.png') + '" style="height: 12px; width: 12px">5</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电量备份 4@2x.png') + '" style="height: 12px; width: 12px">91%</td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/信号备份 2@2x.png') + '" style="height: 12px; width: 12px"></td>' +
                        // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/SIM 流量卡.png') + '" style="height: 12px; width: 12px"></td>' +
                        '</tr>' +
                        '</table>' +
                        '</div>' +
                        '<div style="width: 70%; float: right; padding: 10px 20px 0 20px">' +
                        '<table>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备名称:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        res.data.data[i].devName +
                        '</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备报警:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        cautionStr +
                        '</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备编号:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        res.data.data[i].devImei +
                        '</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">报警时间:</span></td>' +
                        '<td><span style="font-size: 12px">' +
                        res.data.data[i].lRecordTime +
                        '</td>' +
                        '</tr>' +
                        '</table>' +
                        '</div>' +
                        '<div style="width: 100%; height: 70px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px; margin-top: 120px">' +
                        '<span style="font-size: 12px; padding: 0 20px">告警位置：</span><br>' +
                        '<span style="font-size: 12px; padding: 0 20px">' +
                        res.data.data[i].lLonBd09 +
                        ',' +
                        res.data.data[i].lLatBd09 +
                        '</span>' +
                        '</div>' +
                        '<div style="width: 100%; height: 35px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px">' +
                        '<table>' +
                        '<tr>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/help_location.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/help_od.png') +
                        '" style="height: 20px; width: 20"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/help_replay.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/main_msg_off.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '<td style="padding: 2px 8px"><img src="' +
                        require('../assets/images/main_location_off.png') +
                        '" style="height: 20px; width: 20px"></td>' +
                        '</tr>' +
                        '</table>' +
                        '</div>' +
                        '</div>'
                      icon = new BMap.Icon(
                        require('../assets/images/高精度/报警.png'),
                        new BMap.Size(30, 30),
                        {
                          imageSize: new BMap.Size(30, 30)
                        }
                      )
                      // 自定义弹窗对象实例，并存入数组中
                      _this.infoBox.push({
                        infobox: new BMapLib.InfoBox(_this.map, html, {
                          boxStyle: {
                            width: '300px',
                            height: '260px'
                          },
                          offset: new BMap.Size(0, 20),
                          closeIconUrl: require('../assets/images/closeInfoBox.png'),
                          closeIconMargin: '10px 10px 0 0',
                          enableAutoPan: true
                        }),
                        devId: res.data.data[i].devId,
                        open: false
                      })
                    } else {
                      icon = new BMap.Icon(
                        require('../assets/images/高精度/静止.png'),
                        new BMap.Size(30, 30),
                        {
                          imageSize: new BMap.Size(30, 30)
                        }
                      )
                    }
                    _this.markers.push({
                      marker: new BMap.Marker(
                        new BMap.Point(
                          res.data.data[i].lLonBd09,
                          res.data.data[i].lLatBd09
                        ),
                        {
                          icon: icon
                        }
                      ),
                      // 为marker集合元素添加设备ID 方便区分
                      id: res.data.data[i].devId
                    })
                  }
                }
                for (let item in _this.markers) {
                  _this.map.addOverlay(_this.markers[item].marker)
                }
                //  已创建的marker，根据最新数据更新信息
              } else if (_this.markers.length > 0) {
                for (let j = 0; j < _this.markers.length; j++) {
                  for (let n = 0; n < res.data.data.length; n++) {
                    // 根据设备ID获取marker集合中对应的点
                    if (_this.markers[j].id === res.data.data[n].devId) {
                      let icon = null
                      let cautionStr = ''
                      if (
                        res.data.data[n].cId !== null &&
                        res.data.data[n].cId !== ''
                      ) {
                        _this.markers[j].marker.setZIndex(99)
                        let cautionList = res.data.data[n].cId.split(',')
                        for (let item in cautionList) {
                          for (
                            let i = 0;
                            i < _this.dictionaryList.length;
                            i++
                          ) {
                            if (
                              _this.dictionaryList[i].dKey ===
                              cautionList[item] &&
                              _this.dictionaryList[i].dType === 'CAUTION_TYPE'
                            ) {
                              cautionStr =
                                cautionStr +
                                _this.dictionaryList[i].dValue +
                                ','
                            }
                          }
                        }
                      } else {
                        _this.markers[j].marker.setZIndex(1)
                        cautionStr = '设备参数正常'
                      }
                      if (res.data.data[n].flag === false) {
                        _this.markers[j].marker.setZIndex(99)
                        cautionStr = cautionStr + '（出围栏）'
                      } else {
                        _this.markers[j].marker.setZIndex(1)
                      }
                      if (
                        res.data.data[n].devModel === 21 ||
                        res.data.data[n].devModel === 22
                      ) {
                        let electric = null
                        if (res.data.data[n].lElectricQuantity * 1 > 90) {
                          electric = require('../assets/images/电池/100.png')
                        } else if (
                          res.data.data[n].lElectricQuantity * 1 >
                          50
                        ) {
                          electric = require('../assets/images/电池/50-90.png')
                        } else if (
                          res.data.data[n].lElectricQuantity * 1 >
                          20
                        ) {
                          electric = require('../assets/images/电池/20-50.png')
                        } else {
                          electric = require('../assets/images/电池/0-20.png')
                        }
                        let html =
                          '<div style="width: 300px; height: 260px; background-color: #FFFFFF; border-radius: 5px; box-shadow: 3px 3px 3px 3px #e8e8e8;">' +
                          '<div style="width: 100%; height: 35px; border-radius: 5px 5px 0 0; border-bottom: #f1f1f1 solid 1px">' +
                          '<table>' +
                          '<tr>' +
                          '<td style="padding: 0">' +
                          '<div style="float: left; margin-left: 5px"><img src="' +
                          electric +
                          '" style="height: 20px; width: 20px; margin-top: 5px"></div>' +
                          '<div style="float: left; line-height: 30px; font-size: 12px; margin-left: 5px">' +
                          res.data.data[n].lElectricQuantity +
                          '%</div>' +
                          '</td>' +
                          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电备份 3@2x.png') + '" style="height: 12px; width: 12px">15</td>' +
                          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/编组 6@2x.png') + '" style="height: 12px; width: 12px">5</td>' +
                          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电量备份 4@2x.png') + '" style="height: 12px; width: 12px">91%</td>' +
                          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/信号备份 2@2x.png') + '" style="height: 12px; width: 12px"></td>' +
                          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/SIM 流量卡.png') + '" style="height: 12px; width: 12px"></td>' +
                          '</tr>' +
                          '</table>' +
                          '</div>' +
                          '<div style="width: 70%; float: right; padding: 10px 20px 0 20px">' +
                          '<table>' +
                          '<tr>' +
                          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备名称:</span></td>' +
                          '<td><span style="font-size: 12px">' +
                          res.data.data[n].devName +
                          '</td>' +
                          '</tr>' +
                          '<tr>' +
                          '<tr>' +
                          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备报警:</span></td>' +
                          '<td><span style="font-size: 12px">' +
                          cautionStr +
                          '</td>' +
                          '</tr>' +
                          '<tr>' +
                          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备编号:</span></td>' +
                          '<td><span style="font-size: 12px">' +
                          res.data.data[n].devImei +
                          '</td>' +
                          '</tr>' +
                          '<tr>' +
                          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">报警时间:</span></td>' +
                          '<td><span style="font-size: 12px">' +
                          res.data.data[n].lRecordTime +
                          '</td>' +
                          '</tr>' +
                          '</table>' +
                          '</div>' +
                          '<div style="width: 100%; height: 70px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px; margin-top: 120px">' +
                          '<span style="font-size: 12px; padding: 0 20px">告警位置：</span><br>' +
                          '<span style="font-size: 12px; padding: 0 20px">' +
                          res.data.data[n].lLonBd09 +
                          '，' +
                          res.data.data[n].lLatBd09 +
                          '</span>' +
                          '</div>' +
                          '<div style="width: 100%; height: 35px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px">' +
                          '<table>' +
                          '<tr>' +
                          '<td style="padding: 2px 8px"><img src="' +
                          require('../assets/images/help_location.png') +
                          '" style="height: 20px; width: 20px"></td>' +
                          '<td style="padding: 2px 8px"><img src="' +
                          require('../assets/images/help_od.png') +
                          '" style="height: 20px; width: 20"></td>' +
                          '<td style="padding: 2px 8px"><img src="' +
                          require('../assets/images/help_replay.png') +
                          '" style="height: 20px; width: 20px"></td>' +
                          '<td style="padding: 2px 8px"><img src="' +
                          require('../assets/images/main_msg_off.png') +
                          '" style="height: 20px; width: 20px"></td>' +
                          '<td style="padding: 2px 8px"><img src="' +
                          require('../assets/images/main_location_off.png') +
                          '" style="height: 20px; width: 20px"></td>' +
                          '</tr>' +
                          '</table>' +
                          '</div>' +
                          '</div>'
                        // flag=false时，设备处围栏外
                        if (res.data.data[n].flag === false) {
                          // 围栏外标记点ICON替换
                          icon = new BMap.Icon(
                            require('../assets/images/安全帽/报警.png'),
                            new BMap.Size(30, 30),
                            {
                              imageSize: new BMap.Size(30, 30)
                            }
                          )
                          let infoFlag = false
                          // 自定义弹窗中根据设备id锁定对应弹窗对象
                          for (let item in _this.infoBox) {
                            if (
                              _this.infoBox[item].devId ===
                              res.data.data[n].devId
                            ) {
                              // 修改弹窗内容，在新位置重新打开弹窗
                              if (_this.infoBox[item].open) {
                                _this.infoBox[item].infobox.setPosition(
                                  new BMap.Point(
                                    res.data.data[n].lLonBd09,
                                    res.data.data[n].lLatBd09
                                  )
                                )
                                _this.infoBox[item].infobox.setContent(html)
                              }
                              infoFlag = true
                              break
                            }
                          }
                          if (infoFlag === false) {
                            _this.infoBox.push({
                              infobox: new BMapLib.InfoBox(_this.map, html, {
                                boxStyle: {
                                  width: '300px',
                                  height: '260px'
                                },
                                offset: new BMap.Size(0, 20),
                                closeIconUrl: require('../assets/images/closeInfoBox.png'),
                                closeIconMargin: '10px 10px 0 0',
                                enableAutoPan: true
                              }),
                              devId: res.data.data[n].devId,
                              open: false
                            })
                          }
                        } else {
                          // 围栏内关闭弹窗
                          for (let item in _this.infoBox) {
                            if (
                              _this.infoBox[item].devId ===
                              res.data.data[n].devId
                            ) {
                              _this.infoBox[item].infobox.close()
                              break
                            }
                          }
                          icon = new BMap.Icon(
                            require('../assets/images/安全帽/静止.png'),
                            new BMap.Size(30, 30),
                            {
                              imageSize: new BMap.Size(30, 30)
                            }
                          )
                        }
                      }
                      _this.markers[j].marker.addEventListener(
                        'click',
                        function (e) {
                          for (let i = 0; i < _this.infoBox.length; i++) {
                            if (
                              _this.infoBox[i].devId === _this.markers[j].id
                            ) {
                              _this.infoBox[i].infobox.open(
                                _this.markers[j].marker
                              )
                              _this.infoBox[i].open = true
                            } else {
                              _this.infoBox[i].infobox.close()
                              _this.infoBox[i].open = false
                            }
                          }
                        }
                      )
                      _this.markers[j].marker.setPosition(
                        new BMap.Point(
                          res.data.data[n].lLonBd09,
                          res.data.data[n].lLatBd09
                        )
                      )
                      _this.markers[j].marker.setIcon(icon)
                      break
                    }
                  }
                }
              }
            }
          }
        }
      })
  },
  /** 查询组织所有电子围栏
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  getAllEfenceList(_this, url, pageSize, currentPage, efOrgId, efName, includeFailure) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          efOrgId,
          efName,
          includeFailure
        },
        params: {
          pageSize: pageSize,
          pageNum: currentPage
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.efTotalNum = res.data.data.total
          _this.fenceTableData = res.data.data.pag
          _this.efLoading = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询白名单所有电子围栏
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  getWhiteAllEfenceList(_this, url, pageSize, currentPage, orgId, efName) {
    _this
      .$axios({
        method: 'get',
        url: url,
        data: {},
        params: {
          orgId: orgId,
          name: efName,
          pageSize: pageSize,
          pageNum: currentPage
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.efTotalNum = res.data.data.total

          _this.fenceTableData = res.data.data.pag

          console.log('3213213213213213213', _this.fenceTableData)
          _this.efLoading = false
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 新建电子围栏(多边形)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  addPolygonEfence(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          efName: data.efName,
          efGeometry: data.efGeometry,
          efOrgId: data.efOrgId,
          efLocationBd09: data.efLocationBd09,
          efLocationJc02: data.efLocationJc02,
          efWarnType: data.efWarnType,
          efRankCaution: data.efRankCaution,
          efInTimeFlag: data.efInTimeFlag,
          efStatus: data.efStatus
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          if (typeof res.data.data === 'number' && res.data.data == 1) {
            _this.$message({
              message: res.data.message,
              type: 'success'
            })
            _this.ProductActive = null
            _this.newFenc = false
            if (_this.mapType === 'amap') {
            _this.amap.clearMap()
          } else {
            _this.map.clearOverlays()
          }
            _this.refreshEfTable(_this.orgId)
            _this.$refs.newFencForm.resetFields()
          } else {
            _this.$message({
              message: res.data.data.message,
              type: 'warning'
            })
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 新建白名单电子围栏(多边形)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  whiteAddPolygonEfence(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: data,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.data.code == undefined) {
          _this.$message({
            message: res.data.message,
            type: 'success'
          })
          _this.init()
          _this.ProductActive = null
          _this.newFenc = false
          if (_this.mapType === 'amap') {
            _this.amap.clearMap()
          } else {
            _this.map.clearOverlays()
          }
          _this.refreshEfTable(_this.orgId)
        } else {
          _this.$message({
            message: res.data.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 新建白名单电子围栏(多边形)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  whiteDevNum(_this, url) {
    _this
      .$axios({
        method: 'get',
        url: url,
        data: null,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.data.code == undefined) {
          _this.total = res.data.data.personNum
          _this.whiteNum = res.data.data.deviceNum
          _this.intrusionsTotal =
            res.data.data.personNum - res.data.data.deviceNum
        }
      })
  },
  /** 新建电子围栏（圆形）
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param ewId {string} 页面指针
   * @param emplIds {Array} 接口地址
   */
  addCircleEfence(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          efName: data.efName,
          efGeometry: data.efGeometry,
          efOrgId: data.efOrgId,
          efDotBd09: data.efDotBd09,
          efDotJc02: data.efDotJc02,
          efRadius: data.efRadius,
          efWarnType: data.efWarnType,
          efRankCaution: data.efRankCaution,
          efInTimeFlag: data.efInTimeFlag,
          efStatus: data.efStatus
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code == 200) {
          if (typeof res.data.data === 'number' && res.data.data == 1) {
            _this.$message({
              message: res.data.message,
              type: 'success'
            })
            _this.ProductActive = null
            _this.$refs.newFencForm.resetFields()
            _this.newFenc = false
            if (_this.mapType === 'amap') {
            _this.amap.clearMap()
          } else {
            _this.map.clearOverlays()
          }
            _this.refreshEfTable(_this.orgId)
          } else {
            _this.$message({
              message: res.data.data.message,
              type: 'error'
            })
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询组织所有电子围栏
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param efIds {Array} ID集合
   */
  // delEfence(_this, url, efIds) {
  //   _this.$axios({
  //     method: 'post',
  //     url: url,
  //     data: {
  //     },
  //     params: {
  //       efIds: efIds[0]
  //     },
  //     headers: {
  //       Authorization: sessionStorage.getItem('token')
  //     }
  //   }).then((res) => {
  //     console.log(res)
  //     if (res.data.code === 200) {
  //       if (res.data.data.code !== 200) {
  //         _this.$message({
  //           message: res.data.message,
  //           type: 'error'
  //         })
  //       } else {
  //         _this.$message({
  //           message: res.data.message,
  //           type: 'success'
  //         })
  //         _this.map.clearOverlays()
  //         _this.newFenc = false
  //         _this.$refs.newFencForm.resetFields()
  //         _this.refreshEfTable(_this.orgId)
  //       }
  //     } else {
  //       _this.$message({
  //         message: res.data.message,
  //         type: 'warning'
  //       })
  //     }
  //   })
  // },
  /** 删除电子围栏
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param efIds {Array} ID集合
   */
  delEfence(_this, url, efId) {
    _this
      .$axios({
        method: 'post',
        url: url + '?efIds=' + efId,
        data: {},
        params: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          if (res.data.data == 1) {
            _this.$message({
              message: res.data.message,
              type: 'success'
            })
            // _this.init()
            // _this.getList()
            _this.$refs.efenceList.getDevList()
            // _this.map.clearOverlays()// 删除围栏后把地图上显示的围栏清除
            _this.close()
          } else {
            _this.$message({
              message: res.data.data.message,
              type: 'error'
            })
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 查询组织所有电子围栏
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param devIds {String} ID集合
   */
  efenceBindingDevice(_this, url, devIds, efId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          devIds: devIds,
          efId: efId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: res.data.message,
            type: 'success'
          })
          _this.setDevToFenceDialogVisible = false
          _this.$parent.refreshEfTable(_this.orgId)
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 根据电子围栏id查询该电子围栏下绑定的所有设备
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param efId {String} 围栏ID
   */
  getDeviceListByEfId(_this, url, efId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          efId: efId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.devTableData = res.data.data.pag
          _this.efDevIdList = []
          for (let item in res.data.data.pag) {
            _this.efDevIdList.push(res.data.data.pag[item].devId)
          }
          _this.devInfo = false
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 根据电子围栏id查询该电子围栏下绑定的所有设备位置
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param devIds {String} ID集合
   */
  deviceLocationByEfenceId(_this, url, efId, MapType) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          efId: efId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          // 判断是百度地图还是高德地图
          const isBaiduMap = MapType && MapType.Map && MapType.Point && !MapType.isAMap;

          if (res.data.data.length > 0) {
            // 百度地图处理
            if (isBaiduMap) {
              let icon = new MapType.Icon(
                require('../assets/images/car.png'),
                new MapType.Size(40, 40),
                {
                  imageSize: new MapType.Size(40, 40)
                }
              )

              if (_this.markers.length === 0) {
                for (let i in res.data.data) {
                  // 安全帽设备
                  if (
                    res.data.data[i].devModel === 21 ||
                    res.data.data[i].devModel === 22
                  ) {
                    icon = new MapType.Icon(
                      require('../assets/images/安全帽/静止.png'),
                      new MapType.Size(40, 40),
                      { imageSize: new MapType.Size(40, 40) }
                    )
                    // 车辆设备
                  } else if (res.data.data[i].devModel === 5) {
                    icon = new MapType.Icon(
                      require('../assets/images/车辆/静止.png'),
                      new MapType.Size(40, 40),
                      { imageSize: new MapType.Size(40, 40) }
                    )
                    // 高精度锥桶
                  } else if (res.data.data[i].devModel === 30) {
                    icon = new MapType.Icon(
                      require('../assets/images/高精度/静止.png'),
                      new MapType.Size(40, 40),
                      { imageSize: new MapType.Size(40, 40) }
                    )
                    // 中精度锥桶
                  } else if (res.data.data[i].devModel === 17) {
                    icon = new MapType.Icon(
                      require('../assets/images/中精度/静止.png'),
                      new MapType.Size(40, 40),
                      { imageSize: new MapType.Size(40, 40) }
                    )
                    // 人员设备
                  } else if (res.data.data[i].devModel === 18) {
                    icon = new MapType.Icon(
                      require('../assets/images/人/静止.png'),
                      new MapType.Size(40, 40),
                      { imageSize: new MapType.Size(40, 40) }
                    )
                  }
                  _this.markers.push(
                    new MapType.Marker(
                      new MapType.Point(
                        res.data.data[i].lLonBd09,
                        res.data.data[i].lLatBd09
                      ),
                      {
                        icon: icon
                      }
                    )
                  )
                  if (
                    res.data.data[i].devModel === 5 ||
                    res.data.data[i].devModel === 31
                  ) {
                    _this.markers[i].setRotation(res.data.data[i].lDirection)
                  }
                  _this.markers[i].id = res.data.data[i].devId
                  _this.markers[i].addEventListener('click', () => {
                    _this.showPop(res.data.data[i], _this.markers[i])
                    _this.ifInfoBoxShow = true
                  })
                  _this.map.addOverlay(_this.markers[i])
                }
              } else if (_this.markers.length > 0) {
                for (let j in _this.markers) {
                  for (let n in res.data.data) {
                    if (_this.markers[j].id === res.data.data[n].devId) {
                      _this.markers[j].setPosition(
                        new MapType.Point(
                          res.data.data[n].lLonBd09,
                          res.data.data[n].lLatBd09
                        )
                      )
                      if (
                        res.data.data[n].devModel === 5 ||
                        res.data.data[n].devModel === 31
                      ) {
                        _this.markers[j].setRotation(res.data.data[n].lDirection)
                      }
                      break
                    }
                  }
                }
              }
              if (_this.ifInfoBoxShow) {
                for (const i in _this.markers) {
                  if (_this.showId === _this.markers[i].id) {
                    _this.showPop(_this.showRow, _this.markers[i])
                  }
                }
              }
            }
            // 高德地图处理
            else {
              // 调用fence.vue中的addAmapDeviceMarkers方法
              if (typeof _this.addAmapDeviceMarkers === 'function') {
                _this.addAmapDeviceMarkers(res.data.data);
              }
            }
          }
        } else {
          clearInterval(_this.run)
        }
      })
  },
  /** 修改电子围栏(圆形)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {object} 围栏ID
   * @param efId {String} 围栏ID
   */
  updateCircleEfence(_this, url, data, efId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          efId: efId,
          efName: data.efName,
          efGeometry: data.efGeometry,
          efOrgId: data.efOrgId,
          efDotBd09: data.efDotBd09,
          efDotJc02: data.efDotJc02,
          efRadius: data.efRadius,
          efWarnType: data.efWarnType,
          efRankCaution: data.efRankCaution,
          efInTimeFlag: data.efInTimeFlag,
          efStatus: data.efStatus
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '编辑成功',
            type: 'success'
          })
          if (_this.mapType === 'amap') {
            _this.amap.clearMap()
          } else {
            _this.map.clearOverlays()
          }
          _this.newFenc = false
          _this.$refs.newFencForm.resetFields()
          _this.refreshEfTable(_this.orgId)
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 修改电子围栏(多边形)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {object} 围栏ID
   * @param efId {String} 围栏ID
   */
  updatePolygonEfence(_this, url, data, efId) {
    console.log('updatePolygonEfence', data)
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          efId: efId,
          efName: data.efName,
          efGeometry: data.efGeometry,
          efOrgId: data.efOrgId,
          efLocationBd09: data.efLocationBd09,
          efLocationJc02: data.efLocationJc02,
          efWarnType: data.efWarnType,
          efRankCaution: data.efRankCaution,
          efInTimeFlag: data.efInTimeFlag,
          efStatus: data.efStatus
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '编辑成功',
            type: 'success'
          })
          if (_this.mapType === 'amap') {
            _this.amap.clearMap()
          } else {
            _this.map.clearOverlays()
          }
          _this.newFenc = false
          _this.refreshEfTable(_this.orgId)
          _this.$refs.newFencForm.resetFields()
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /** 修改白名单电子围栏(多边形)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param data {object} 围栏ID
   * @param efId {String} 围栏ID
   */
  updateWhitePolygonEfence(_this, url, data, efId) {
    _this
      .$axios({
        method: 'put',
        url: url,
        data: data,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.data.code == undefined) {
          _this.$message({
            message: '编辑成功',
            type: 'success'
          })
          if (_this.mapType === 'amap') {
            _this.amap.clearMap()
          } else {
            _this.map.clearOverlays()
          }
          _this.newFenc = false
          _this.isEditBtn = false

          _this.refreshEfTable(_this.orgId)
          _this.$refs.newFencForm.resetFields()
        } else {
          console.log(res)
          _this.$message({
            message: res.data.data.message,
            type: 'warning'
          })
        }
      })
  },
  /**
   查询报警未处理数量
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getCautionCount(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          let arr = document.getElementById('warnIcon')
          if (res.data.data.undisposedNum === 0) {
            _this.warnNum = null
            arr.classList.remove('ifWarn')
          } else {
            _this.warnNum = res.data.data.undisposedNum
            if (!arr.length) {
              arr.classList.add('ifWarn')
            }
          }
        }
      })
  },
  /**
   根据报警id处理该条报警信息
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  disposeCaution(_this, url, data) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: data,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$refs.unTreadedTable.clearSelection()
          _this.$message({
            message: '告警处理成功',
            type: 'success'
          })
          _this.delCIdList = ''
          _this.searchFun()
        }
      })
  },
  /**
   根据设备id查询该设备实时位置信息、该设备信息、该设备所属组织信息、可查看多个设备、至少选择一个设备查看、列表无分页
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getLocationByDevIdRoute(_this, url, devId, BMap) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devIdList: [devId]
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          let icon = null
          // 安全帽设备
          icon = _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlBDMap(
            _this,
            res.data.data.pag[0]
          )
          _this.marker = new BMap.Marker(
            new BMap.Point(
              res.data.data.pag[0].lLonBd09,
              res.data.data.pag[0].lLatBd09
            ),
            {
              icon: icon
            }
          )
          // 车辆设备列表
          let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29, 32, 33, 42, 43, 40, 45, 41, 44, 46, 48];
          // 船舶设备列表
          let shipKeyList = [6, 31];

          // 为车辆和船舶设备设置方向
          if (carKeyList.indexOf(res.data.data.pag[0].devModel) > -1 ||
              shipKeyList.indexOf(res.data.data.pag[0].devModel) > -1) {
            _this.marker.setRotation(res.data.data.pag[0].lDirection || 0);
          }
          console.log(_this.marker)
          _this.map.addOverlay(_this.marker)
          _this.map.setViewport([
            new BMap.Point(
              res.data.data.pag[0].lLonBd09,
              res.data.data.pag[0].lLatBd09
            )
          ])
          _this.play = true
        } else {
        }
      })
  },
  /**
   查询设备信息、列表+分页、【可根据组织id、设备imei编号、设备名称(模糊查询)、设备实时状态查询】
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param pageNum {number} 分页页码
   * @param pageSize {number} 分页容量
   */
  efenceCaution(_this, url, pageNum, pageSize, orgId, devName) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          orgId: orgId,
          devName: devName
        },
        params: {
          pageNum: pageNum,
          pageSize: pageSize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.orgdevlist = res.data.data.pag
          _this.totalNum = res.data.data.total
          // _this.deviceTable = false
          _this.miniTable = false
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /**
   查询围栏报警汇总、列表+分页、【可根据年、月、自定义时间段查询】
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  listEfenceDeviceVO(_this, url, year, month, beginTime, endTime, devId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          year: year,
          month: month,
          beginTime: beginTime,
          endTime: endTime,
          devImei: devId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        console.log(res)
        if (res.data.code === 200) {
          let date = new Date()
          let today =
            date.getFullYear() +
            '-' +
            (date.getMonth() + 1 < 10 ? '0' : '') +
            (date.getMonth() + 1) +
            '-' +
            (date.getDate() < 10 ? '0' : '') +
            date.getDate()
          _this.analyseCaution = []
          if (res.data.data.pag !== null) {
            for (let item in res.data.data.pag) {
              if (res.data.data.pag[item].date <= today) {
                _this.analyseCaution.push(res.data.data.pag[item])
              }
            }
            _this.sTotalNum = res.data.data.total
            _this.cautionInfo = false
            _this.echartsDrawPie()
            _this.echartsDraw()
          } else {
            _this.$message({
              message: '当前时间范围内无数据记录',
              type: 'warning'
            })
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /**
   查询设备里程统计、列表+分页、【可根据年、月、自定义时间段查询】
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  listDeviceMileageVO(_this, url, year, month, beginTime, endTime, devImei) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          year: year,
          month: month,
          beginTime: beginTime,
          endTime: endTime,
          devImei: devImei
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          let date = new Date()
          let today =
            date.getFullYear() +
            '-' +
            (date.getMonth() + 1 < 10 ? '0' : '') +
            (date.getMonth() + 1) +
            '-' +
            (date.getDate() < 10 ? '0' : '') +
            date.getDate()
          _this.analyseMiles = []
          if (res.data.data.pag !== null) {
            for (let item in res.data.data.pag) {
              if (res.data.data.pag[item].drivingDate <= today) {
                _this.analyseMiles.push(res.data.data.pag[item])
              }
            }
            _this.sTotalNum = res.data.data.total
            _this.milesInfo = false
            _this.echartsDraw()
          } else {
            _this.$message({
              message: '当前时间范围内无数据记录',
              type: 'warning'
            })
          }
        } else {
          console.log(res)
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /**
   查询围栏报警汇总、列表+分页、【可根据年、月、自定义时间段查询】
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  deviceCautionListCaution(
    _this,
    url,
    beginTime,
    endTime,
    devId,
    cType,
    cCode,
    pageNum,
    pageSize
  ) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          cType: cType,
          cCode: cCode,
          beginTime: beginTime,
          endTime: endTime,
          devId: devId
        },
        params: {
          pageNum: pageNum,
          pageSize: pageSize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          if (res.data.data.pag.length > 0) {
            _this.analyseRoute = res.data.data.pag
            _this.cTotalNum = res.data.data.total
            for (let item in _this.analyseRoute) {
              let lng = _this.analyseRoute[item].cLonBd09 * 1
              let lat = _this.analyseRoute[item].cLatBd09 * 1
              _this.analyseRoute[item].coordinate =
                lng.toFixed(6) + ',' + lat.toFixed(6)
            }
            _this.searchLoading = false
            // _this.echartsDraw()
          } else {
            _this.$message({
              message: '当前时间范围内无数据记录',
              type: 'warning'
            })
            _this.analyseRoute = []
            _this.searchLoading = false
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
  },
  /**
   睡眠指令下发
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param devImei {string} 设备IMEI
   * @param instructType {string} 指令msgId
   */
  instructSend(_this, url, devImei, instructType) {
    let usernameNow = JSON.parse(sessionStorage.getItem('userInfo')).username
    let uOrgIdNow = JSON.parse(sessionStorage.getItem('userInfo')).uOrgId
    _this
      .$axios({
        method: 'post',
        url: url,
        data: [{ devTopic: devImei, mesBody: { msgId: instructType } }],
        params: {
          uOrgIdNow: uOrgIdNow,
          usernameNow: usernameNow
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '指令发送成功',
            type: 'success'
          })
          _this.instructDialogVisible = false
        } else {
          _this.$message({
            message: '指令发送失败',
            type: 'warning'
          })
        }
      })
  },
  /**
   围栏告警统计(实时)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  efenceCautionNow(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.efenceCautionNowData = res.data.data
          _this.efenceCautionNow()
          _this.efenceCautionNowLoading = false
        } else {
          console.log(res)
        }
      })
  },
  /**
   设备状态统计(实时)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  deviceStateNow(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.deviceStateNowData = res.data.data
          _this.deviceStateNow()
          _this.deviceStateNowLoading = false
        } else {
          console.log(res)
        }
      })
  },
  /**
   告警类型统计
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  cautionType(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.cautionTypeData = res.data.data
          _this.cautionType()
          _this.cautionTypeLoading = false
        } else {
          console.log(res)
        }
      })
  },
  /**
   作业数量统计
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  workNum(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.workNumData = res.data.data
          _this.workNum()
          _this.workNumLoading = false
        } else {
          console.log(res)
        }
      })
  },
  /**
   根据数据辞典id查询子节点（新建设备页面）
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getChildDicByPid(_this, url, dId) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devModelId: dId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.devProtocolType = []
          _this.creatFrom.devType = res.data.data[0].devTypeKey
          _this.devProtocolType.push({
            dKey: res.data.data[0].devProtocalKey,
            dValue: res.data.data[0].devProtocalValue
          })
          _this.creatFrom.devProtocolType = res.data.data[0].devProtocalKey
        } else {
          console.log(res)
        }
      })
  },
  /**
   根据数据辞典id查询子节点(设备编辑页面)
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getChildDicByPidForEditDev(_this, url, dId, toDo) {
    _this
      .$axios({
        method: 'get',
        url: url,
        params: {
          dId: dId
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          if (toDo === 'getDevModel') {
            _this.devInfoData.devProtocolType = ''
            _this.devModelData = res.data.data.list
          } else if (toDo === 'getProtocolType') {
            _this.devInfoData.devProtocolType = res.data.data.list[0].dKey
            _this.devProtocolTypeData = res.data.data.list
          }
        } else {
          console.log(res)
        }
      })
  },
  /**
   新增设备、Excel导入
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param excelFileData {Object}
   */
  insertByExcel(_this, url, excelFileData) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: excelFileData,
        contentType: false,
        processData: false,
        cache: false,
        dataType: 'json',
        responseType: 'blob',
        params: {},
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.type === 'application/octet-stream') {
          let link = document.createElement('a')
          link.href = URL.createObjectURL(
            new Blob([res.data], { type: 'application/vnd.ms-excel' })
          )
          link.download = '设备批量导入结果'
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href)
          document.getElementById('excelFile').value = ''
          _this.handleNodeClick(_this.treeOrgId)
        } else if (res.data.type === 'application/json') {
          _this.$message({
            duration: 3000,
            message: '导入失败,请检查Excel文件格式是否符合模板格式后重试！',
            type: 'warning'
          })
          document.getElementById('excelFile').value = ''
          _this.handleNodeClick(_this.treeOrgId)
          // let reader = new FileReader()
          // reader.readAsText(res.data, 'utf-8')
          // reader.addEventListener('loadend', function () {
          //   let res = JSON.parse(reader.result)
          // })
        }
      })
  },
  /**
  上传升级包
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param otaInfo {FormData} 请求体
   */
  uploadOtaFile(_this, url, otaInfo) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: otaInfo,
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        console.log(otaInfo.get('file'))
        if (res.data.code === 200) {
          _this.$message({
            message: '升级包上传成功！',
            type: 'success'
          })
          _this.fd = null
          _this.fd = new FormData()
          _this.$refs.creatFrom.resetFields()
          document.getElementById('otaFile').value = ''
          _this.OtaCtrDialogVisible = false
          _this.$parent.getOtalist()
        } else if (res.data.code === 301) {
          _this.$message({
            message: '上传失败,请检查升级包文件格式是否正确！！',
            type: 'warning'
          })
          document.getElementById('otaFile').value = ''
        } else {
          document.getElementById('otaFile').value = ''
          _this.tableloading = false
        }
      })
  },
  /**
   查询告警列表、可根据报警时间区间查询、报警类型查询、报警编码查询、是否处理查询
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  listCautionExpressways(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          cType: 'CAUTION_TYPE',
          cCode: _this.cCode,
          ewId: _this.ewId,
          cRecordTimeBegin: _this.daterange[0],
          cRecordTimeEnd: _this.daterange[1]
        },
        params: {
          pageNum: _this.cCurrentPage,
          pageSize: _this.cPagesize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.listCautionExpresswaysTableData = res.data.data.pag
          _this.cTotalNum = res.data.data.total
          _this.tableloading = false
        } else {
          console.log(res)
        }
      })
  },
  /**
   查询告警列表、可根据报警时间区间查询、报警类型查询、报警编码查询、是否处理查询
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param cIds {string} 接口地址
   */
  disposeCautionExpressway(_this, url, cIds) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          cautionExpresswayIds: cIds
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '操作成功！',
            type: 'success'
          })
          _this.getListCautionExpressways()
        } else {
          console.log(res)
        }
      })
  },
  /**
   查询升级包
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  listUpgrade(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          pageNum: _this.currentPage,
          pageSize: _this.pagesize
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.otaTableData = res.data.data.pag
          _this.totalNum = res.data.data.total
          _this.tableloading = false
        }
      })
  },
  /**
   删除升级包
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  delUpgrade(_this, url) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {},
        params: {
          upgradeIds: _this.delList[0]
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            message: '删除成功！',
            type: 'success'
          })
          _this.getOtalist()
          _this.tableloading = false
        } else {
          _this.$message({
            message: '删除失败，请重试！',
            type: 'warning'
          })
          _this.getOtalist()
          _this.tableloading = false
        }
      })
  }
}
export default ApiCtl



// WEBPACK FOOTER //
// ./src/javascript/Api.js